const UPDATE_CHANGEREQUESTS = 'myChangeRequests/UPDATE_CHANGEREQUESTS';
const UPDATE_ISLOADING = 'myChangeRequests/UPDATE_ISLOADING';

export default {
  UPDATE_CHANGEREQUESTS,
  UPDATE_ISLOADING
};
